// export const API_URL = 'http://localhost:8080/api/v1';
export const API_URL = "https://map.seol.center/api/v1";
// export const API_URL = "http://192.168.1.4:8080/api/v1";
